import type { Product, ProductVariant } from "../types";

export const capFirst = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export function groupVariants(variants: ProductVariant[]): Product[] {
  const map = new Map<string, Product>();
  for (const v of variants) {
    if (!map.has(v.name)) {
      map.set(v.name, {
        name: capFirst(v.name),
        sizes: [],
        image: v.image,
        salePrice: v.salePrice,
        category: v.category,
        isNew: v.isNew,
        variants: [],
      });
    }
    const p = map.get(v.name)!;
    if (!p.sizes.includes(v.size)) p.sizes.push(v.size);
    p.variants.push(v);
  }
  return Array.from(map.values());
}
